/**
 * Formatting matching the desktop app's output.
 *
 * Money was rendered as `{value:N0} MKD` with Math.Floor applied on the tiles
 * (frmShpenzimetAktualeStargym.cs:84), so both are reproduced here rather than
 * quietly rounding differently and making totals look wrong to the client.
 */

const numberFormat = new Intl.NumberFormat('sq-MK', { maximumFractionDigits: 0 });

export function formatMkd(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '0 MKD';
  return `${numberFormat.format(Math.floor(n))} MKD`;
}

export function formatNumber(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  return Number.isFinite(n) ? numberFormat.format(n) : '0';
}

/** ISO date (what the API returns) to the dd/MM/yyyy the desktop grids show. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const [year, month, day] = iso.slice(0, 10).split('-');
  if (!year || !month || !day) return iso;
  return `${day}/${month}/${year}`;
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

/** Default grid range: one month back, matching frmStargym_Load. */
export function monthAgoIso(): string {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return d.toISOString().slice(0, 10);
}
